import {
    getNewsLetterRepo, postNewsLetterTestRunRepo, postNewsLetterPreviewRepo, getNewsLetterCalendarRepo, deleteNewsLetterItemsRepo
} from "../repositories/newsletter"
import { createSlice } from "@reduxjs/toolkit";

const newsLetterSlice = createSlice({
    name: "newsLetterReducer",

    initialState: {

        newsLetterCardsLoading: false,
        newsLetterCardsData: null,
        newsLetterCardsError: null,

        newsLetterTestRunLoading: false,
        newsLetterTestRunData: null,
        newsLetterTestRunError: null,

        newsLetterPreviewLoading: false,
        newsLetterPreviewData: null,
        newsLetterPreviewError: null,

        newsLetterCalendarLoading: false,
        newsLetterCalendarData: null,
        newsLetterCalendarError: null,

        newsLetterItemsLoading: false,
        newsLetterItemsData: null,
        newsLetterItemsError: null,

    },

    reducers: {
        getNewsLetterCardsLoading(state, action) {
            return {
                ...state,
                newsLetterCardsLoading: true,
            };
        },
        getNewsLetterCardsSuccess(state, action) {
            return {
                ...state,
                newsLetterCardsLoading: false,
                newsLetterCardsData: action.payload,
            };
        },
        getNewsLetterCardsFailure(state, action) {
            return {
                ...state,
                newsLetterCardsLoading: false,
                newsLetterCardsError: action.payload,
            };
        },
        clearGetNewsLetterCardsReponse(state, action) {
            return {
                ...state,
                newsLetterCardsData: null,
                newsLetterCardsError: null,
            };
        },
        getNewsLetterPreviewLoading(state, action) {
            return {
                ...state,
                newsLetterPreviewLoading: true,
                newsLetterPreviewData: null,   // reset so useEffect always fires on success
                newsLetterPreviewError: null,
            };
        },
        getNewsLetterPreviewSuccess(state, action) {
            return {
                ...state,
                newsLetterPreviewLoading: false,
                newsLetterPreviewData: action.payload,
            };
        },
        getNewsLetterPreviewFailure(state, action) {
            return {
                ...state,
                newsLetterPreviewLoading: false,
                newsLetterPreviewError: action.payload,
            };
        },
        clearNewsLetterPreviewData(state, action) {
            return {
                ...state,
                newsLetterPreviewData: null,
                newsLetterPreviewError: null,
            };
        },

        postNewsLetterTestRunLoading(state, action) {
            return {
                ...state,
                newsLetterTestRunLoading: true,
            };
        },
        postNewsLetterTestRunSuccess(state, action) {
            return {
                ...state,
                newsLetterTestRunLoading: false,
                newsLetterTestRunData: action.payload,

            };
        },
        postNewsLetterTestRunFailure(state, action) {
            return {
                ...state,
                newsLetterTestRunLoading: false,
                newsLetterTestRunError: action.payload,
            };
        },
        getNewsLetterCalendarLoading(state, action) {
            return {
                ...state,
                newsLetterCalendarLoading: true,
            };
        },
        getNewsLetterCalendarSuccess(state, action) {
            return {
                ...state,
                newsLetterCalendarLoading: false,
                newsLetterCalendarData: action.payload,
            };
        },


        getNewsLetterCalendarFailure(state, action) {
            return {
                ...state,
                newsLetterCalendarLoading: false,
                newsLetterCalendarError: action.payload,
            };
        },
        deleteNewsLetterItemsLoading(state, action) {
            return {
                ...state,
                newsLetterItemsLoading: true,
            };
        },
        deleteNewsLetterItemsSuccess(state, action) {
            return {
                ...state,
                newsLetterItemsLoading: false,
                newsLetterItemsData: action.payload,
            };
        },
        deleteNewsLetterItemsFailure(state, action) {
            return {
                ...state,
                newsLetterItemsLoading: false,
                newsLetterItemsError: action.payload,

            };
        },
        clearNewsLetterItemsReponse(state, action) {//remove
            return {
                ...state,
                newsLetterItemsData: null,
                newsLetterItemsError: null,
            };
        },




    }
})
export const {
    getNewsLetterCardsLoading,
    getNewsLetterCardsSuccess,
    getNewsLetterCardsFailure,
    clearGetNewsLetterCardsReponse,

    getNewsLetterPreviewLoading,
    getNewsLetterPreviewSuccess,
    getNewsLetterPreviewFailure,
    clearNewsLetterPreviewData,

    postNewsLetterTestRunLoading,
    postNewsLetterTestRunSuccess,
    postNewsLetterTestRunFailure,

    getNewsLetterCalendarLoading,
    getNewsLetterCalendarSuccess,
    getNewsLetterCalendarFailure,

    deleteNewsLetterItemsLoading,
    deleteNewsLetterItemsSuccess,
    deleteNewsLetterItemsFailure,
    clearNewsLetterItemsReponse,


} = newsLetterSlice.actions;


export const getnewsLetter = (params) => {
    return async (dispatch) => {
        dispatch(getNewsLetterCardsLoading());
        await getNewsLetterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getNewsLetterCardsSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getNewsLetterCardsFailure(error.message));
                }
            });
    };
};

export const postNewsLetterPreview = (data) => {
    return async (dispatch) => {
        dispatch(getNewsLetterPreviewLoading());
        await postNewsLetterPreviewRepo(data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getNewsLetterPreviewSuccess(response.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getNewsLetterPreviewFailure(error.message));
                }
            });
    };
};

export const postNewsLetterTestRun = (params) => {
    return async (dispatch) => {
        dispatch(postNewsLetterTestRunLoading());
        await postNewsLetterTestRunRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(postNewsLetterTestRunSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    console.log("error...........", error?.response?.data?.message);
                    dispatch(postNewsLetterTestRunFailure(error?.response?.data?.message));
                }
            });
    };
};

export const getNewsLetterCalendar = (params) => {

    return async (dispatch) => {
        dispatch(getNewsLetterCalendarLoading());
        await getNewsLetterCalendarRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getNewsLetterCalendarSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getNewsLetterCalendarFailure(error.message));
                }
            });
    };
};

export const deleteNewsLetterItems = (params) => {
    return async (dispatch) => {
        dispatch(deleteNewsLetterItemsLoading());
        await deleteNewsLetterItemsRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(deleteNewsLetterItemsSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(deleteNewsLetterItemsFailure(error.message));
                }
            });
    };
};






export default newsLetterSlice.reducer